// src/services/chatService.js
import axios from 'axios';
import { env } from 'configs/EnvironmentConfig';

const getChatMicroserviceBaseUrl = () =>
  env?.IFRAME_CHAT_URL || env?.BASE_URL || 'https://chat-microservice.voiceracx.ai';

const normalizeChatResponse = (data) => {
  const completion =
    data?.completion ??
    data?.message ??
    data?.answer ??
    null;

  return {
    ...data,
    completion,
  };
};

const postChatMessage = async (path, payload) => {
  const apiBaseUrl = getChatMicroserviceBaseUrl();
  const url = `${apiBaseUrl}${path}`;
  const { data } = await axios.post(url, payload, {
    headers: { 'Content-Type': 'application/json' },
  });
  return normalizeChatResponse(data);
};

/**
 * In-app "Chat with Agent" panel — chat microservice `/chatagent/chat`.
 */
export const sendUiChatMessageToAgent = async ({ chat_agent_id, message, chat_id, user_id }) => {
  return postChatMessage('/chatagent/chat', { chat_agent_id, message, chat_id, user_id });
};

/**
 * Embed / iframe widget — chat microservice `/chatagent/iframechat`.
 *
 * Returns full response `data` (e.g. `is_connected_to_flex`) plus a `completion` field.
 */
export const sendMessageToAgent = async ({ chat_agent_id, message, chat_id, user_id }) => {
  return postChatMessage('/chatagent/iframechat', { chat_agent_id, message, chat_id, user_id });
};
